// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__35W_9","clinicsSelect":"TableHeading_clinicsSelect__3Jits"};